import axios from "axios";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import Select, {createFilter} from "react-select";
import {useTable} from "react-table";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {getAccountManagerDatatableDetails, getAccountManagerDatatableDetailsApi, getAccountUserListApi} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import {useForm} from "react-hook-form";
import ConsoleHelper from "../ConsoleHelper";

let count = 0;
function AccountManagerDatatable(props) {
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [visibleToUserSelectData, setVisibleToUserSelectData] = useState([]);
    const [selectedVisibleToUser, setSelectedVisibleToUser] = useState();
    const [accountOwnerSelectData, setAccountOwnerelectData] = useState([]);
    const [selectedAccountOwner, setSelectedAccountOwner] = useState();
    const [data, setData] = useState([]);
    const [rtaNumber, setRtaNumber] = useState();
    const [holder, setHolder] = useState();
    const [isTableVisible, setIsTableVisible] = useState();
    const [settlementScheduleOptions, setSettlementScheduleOptions] = useState();
    const [selectedSettlementScheduleOrder, setSettlementScheduleOrder] = useState();
    const [surchargeScheduleOptions, setSurchargeScheduleOptions] = useState();
    const [selectedSurchargeScheduleOrder, setSurchargeScheduleOrder] = useState();
    const [interchangeScheduleOptions, setInterchangeScheduleOptions] = useState();
    const [selectedInterchangeScheduleOrder, setInterchangeScheduleOrder] = useState();
    const [consolidationOptions, setConsolidationOptions] = useState();
    const [selectedConsolidationOrder, setConsolidationOrder] = useState();
    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const [perPage, setPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [resetUserForm, setResetUserForm] = useState(false);
    const [isDatatableLoaded, setDatatableLoaded] = useState(0);
    const history = useHistory();
    const location = useLocation();

    const {
        reset,
        formState: { errors }
    } = useForm();
    //  Internally, customStyles will deep merges your customStyles with the default styling.
    const tableStyles = {
        rows: {
            style: {
                minHeight: '30px',
                fontSize: '10px',// override the row height
            },
        },
        headCells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
                fontWeight: 'bold',
                textDecoration: 'underline'
            },
        },
        cells: {
            style: {
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: '10px',
                wordBreak: 'break-word',
            },
            draggingStyle: {},
        },
        dataTableExt: {
            style: {
                Width:'40px',
            },
        },
        rdt_TableHeadRow: {
            backgroundColor : 'red',
        }
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
            width: "9vw",
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };


    const datacolumns = [
        {
            name: '',
            grow: 0,
            cell: row => <img height="24px" width="26px" src="assets/images/icons/eyeOpen.png" />,
        },
        {
            name: 'RTA ',
            selector: row => row.rta,
            sortable: true,
        },
        {
            name: 'Holder Name ',
            selector: row => row.holderName,
            sortable: true,
        },
        {
            name: 'Consolidation ',
            selector: row => row.consolidationTypeDesc,
            sortable: true,
        },
        {
            name: 'Settlement Schedule ',
            selector: row => row.settlementScheduleTypeDesc,
            sortable: true,
        },
        {
            name: 'Surcharge Schedule ',
            selector: row => row.surchargeScheduleTypeDesc,
            sortable: true,
        },
        {
            name: 'Interchange Schedule ',
            selector: row => row.interchangeScheduleTypeDesc,
            sortable: true,
        },
        {
            name: 'Status ',
            selector: row => row.status,
            sortable: true,
        }
    ];

    const exportPDF = () => {
        const unit = "pt";
        const size = "A4";
        const orientation = "portrait";

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "Transaction history Report";
        const headers = [
            [
                "seqNo",
                "Tran Time",
                "Type",
                "From Acct"
            ],
        ];

        const pdata = data?.map((elt) => [...Object.values(elt)]);

        let content = {
            startY: 50,
            head: headers,
            body: pdata,
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("report.pdf");
    };

    const onRowClicked = row => {
        history.push({
            pathname: "/accountManager/properties",
            search: `rta=${row.rta}&AccountID=${row.accountID}`,
        });
        ConsoleHelper(row)
        //setData(updatedData);
    };

    useEffect(() => {

        const getUsers = async () => {
            console.log(" GET USERS BY LIST")

            const result = null;
            //const result = await axios.get(`${getAccountUserListApi}?paramUserID=${loggedUserStorage}`);
           console.log(" ---- ",result)

            //setUserOptions(result?.data?.response);
            setSelectedUser({
                label: loggedUserStorage,
                value: loggedUserStorage,
            });

        };
        setSettlementScheduleOptions([
            { label: "All", value: "-1" },
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Threshold", value: "Threshold" },
        ]);

        setSurchargeScheduleOptions([
            { label: "All", value: "-1" },
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Threshold", value: "Threshold" },
        ]);

        setInterchangeScheduleOptions([
            { label: "All", value: "-1" },
            { label: "Daily", value: "Daily" },
            { label: "Weekly", value: "Weekly" },
            { label: "Monthly", value: "Monthly" },
            { label: "Threshold", value: "Threshold" },
        ]);

        setConsolidationOptions([
            { label: "All", value: "-1" },
            { label: "No Consolidation", value: "No Consolidation" },
            { label: "Consolidate Across Funds Type", value: "Consolidate Across Funds Type" },
            { label: "Consolidate Across Terminals", value: "Consolidate Across Terminals" },
            { label: "Full Consolidation", value: "Full Consolidation" },
        ]);
        getUsers();
        return () => {
            setData([]);
            setVisibleToUserSelectData([]);
            setAccountOwnerelectData([]);
            setUserOptions([]);

        };
    }, [location]);


    useEffect(() => {
        const terminalId = location?.search?.split("=")?.[1];
        const getLocationandTerminals = async () => {
            const selectedUserByDefault = (typeof selectedUser?.userId == "undefined") ? loggedUserStorage : selectedUser?.userId;
            var feed = {userId: loggedUserStorage, label: loggedUserStorage, value: loggedUserStorage};
            console.log(" Logged In user",selectedUserByDefault)
            const resultUser = await axios.get(`${getAccountUserListApi}?paramUserID=${selectedUserByDefault}`);
            //console.log(" GET LOCATION BY USERID BY SELECTED USER",resultUser?.data)
            resultUser?.data.unshift(feed);
            setVisibleToUserSelectData(resultUser?.data);
            setAccountOwnerelectData(resultUser?.data)
            if(resultUser?.data != undefined) {
                setSelectedVisibleToUser({
                    label: loggedUserStorage,
                    value: loggedUserStorage,
                });
                setSelectedAccountOwner({
                    label: "All",
                    value: "-1",
                });
            }else{
                setSelectedVisibleToUser([])
            }
            setSettlementScheduleOrder({
                label: "All",
                value: "-1",
            });
            setSurchargeScheduleOrder({
                label: "All",
                value: "-1",
            });
            setInterchangeScheduleOrder({
                label: "All",
                value: "-1",
            });
            setConsolidationOrder({
                label: "All",
                value: "-1",
            });
        };

        getLocationandTerminals();
        return () => {
            setVisibleToUserSelectData([]);
            setAccountOwnerelectData([]);
        };
    }, [resetUserForm]);

    const handleReset = async (e) => {
        console.log(" resetting form")
        setResetUserForm(true);
    };

    const createNewAccountManager = async (e) => {
        history.push({
            pathname: "/accountManager/properties",
        });

    };

    const retrieveReport = async (e) => {
        ++count;
        console.log(" getting report ",count)
        setDatatableLoaded(count);
    };
    useEffect(() => {
    const handleGetReport = async () => {
        try {
            //${selectedVisibleToUser?.value}
            var rta = (typeof rtaNumber === 'undefined')? '-1': rtaNumber;
            console.log(" rtaNumber ",rta )
            console.log(" paramHolderName ",holder)
            console.log(" paramSettSchedule ",selectedSettlementScheduleOrder?.value)
            console.log(" paramSurchargeSchedule ",selectedSurchargeScheduleOrder?.value)
            console.log(" paramIntSchedule ",selectedInterchangeScheduleOrder?.value)
            console.log(" paramConsolidation ",selectedInterchangeScheduleOrder?.value)
            console.log(" paramOwner ",selectedVisibleToUser?.value)
            console.log("paramUserID",selectedAccountOwner?.value)
            const totalRecordsresult = await axios.get(`${getAccountManagerDatatableDetailsApi}?paramRTA=${(typeof rtaNumber === 'undefined')? '-1': rtaNumber}&paramHolderName=${(typeof holder === 'undefined')? '-1': holder}&paramSettSchedule=${(typeof selectedSettlementScheduleOrder === 'undefined')? '-1': selectedSettlementScheduleOrder?.value}&paramSurchargeSchedule=${(typeof selectedSurchargeScheduleOrder === 'undefined')? '-1': selectedSurchargeScheduleOrder?.value}&paramIntSchedule=${(typeof selectedInterchangeScheduleOrder === 'undefined')? '-1': selectedInterchangeScheduleOrder?.value}&paramConsolidation=${(typeof selectedConsolidationOrder === 'undefined')? '-1': selectedConsolidationOrder?.value}&paramUserID=Administrator&paramOwner=${(typeof selectedAccountOwner?.value === 'undefined')? '-1': selectedAccountOwner?.value}&PageSize=10000000&CurrentPage=${currentPage}`);

            const result = await axios.get(`${getAccountManagerDatatableDetailsApi}?paramRTA=${(typeof rtaNumber === 'undefined')? '-1': rtaNumber}&paramHolderName=${(typeof holder === 'undefined')? '-1': holder}&paramSettSchedule=${(typeof selectedSettlementScheduleOrder === 'undefined')? '-1': selectedSettlementScheduleOrder?.value}&paramSurchargeSchedule=${(typeof selectedSurchargeScheduleOrder === 'undefined')? '-1': selectedSurchargeScheduleOrder?.value}&paramIntSchedule=${(typeof selectedInterchangeScheduleOrder === 'undefined')? '-1': selectedInterchangeScheduleOrder?.value}&paramConsolidation=${(typeof selectedConsolidationOrder === 'undefined')? '-1': selectedConsolidationOrder?.value}&paramUserID=Administrator&paramOwner=${(typeof selectedAccountOwner?.value === 'undefined')? '-1': selectedAccountOwner?.value}&PageSize=${perPage}&CurrentPage=${currentPage}`);
            console.log(" get result data ",result?.data?.response);
            setTotalRecords(totalRecordsresult?.data?.response?.length);
            //setTotalRecords(5000);
            setData(result?.data?.response);
            setIsTableVisible(true);
        } catch (error) {
            console.log(" ---- ",error)
        }
    };
        handleGetReport();

    }, [currentPage,isDatatableLoaded]);

    return (
        <div>
            <div className="row mt-4">
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between">
                        <label>RTA Number:</label>
                        <div>
                            <input
                                type="text"
                                class="form-control form-control-sm"
                                style={{ width: "12.5vw" }}
                                onChange={(e) =>
                                    setRtaNumber(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between ">
                        <label>Holder Name:</label>
                        <div>
                            <input
                                type="text"
                                class="form-control form-control-sm"
                                style={{ width: "12.5vw" }}
                                onChange={(e) =>
                                    setHolder(
                                        (e.target.value)
                                    )
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Settlement Schedule:</label>
                        <div>
                            <Select
                                options={settlementScheduleOptions}
                                value={selectedSettlementScheduleOrder}
                                onChange={(e) => setSettlementScheduleOrder(e)}
                                filterOption={createFilter({ ignoreAccents: false })}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/*  */}
            <div className="row mt-3">
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Surcharge Schedule:</label>
                        <div>
                            <Select
                                options={surchargeScheduleOptions}
                                value={selectedSurchargeScheduleOrder}
                                onChange={(e) => setSurchargeScheduleOrder(e)}
                                filterOption={createFilter({ ignoreAccents: false })}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                styles={customStyles}
                            />
                        </div>
                    </div>

                </div>
                <div className="col col-md-4">
                        <div className="d-flex justify-content-between ">
                            <label>Interchange Schedule:</label>
                            <div>
                                <Select
                                    options={interchangeScheduleOptions}
                                    value={selectedInterchangeScheduleOrder}
                                    onChange={(e) => setInterchangeScheduleOrder(e)}
                                    filterOption={createFilter({ ignoreAccents: false })}
                                    captureMenuScroll={false}
                                    classNamePrefix="custom-select"
                                    components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                </div>
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Consolidation:</label>
                        <div>
                            <Select
                                options={consolidationOptions}
                                value={selectedConsolidationOrder}
                                onChange={(e) => setConsolidationOrder(e)}
                                filterOption={createFilter({ ignoreAccents: false })}
                                captureMenuScroll={false}
                                classNamePrefix="custom-select"
                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Visible To User:</label>
                        <div>
                            <Select
                                options={visibleToUserSelectData}
                                value={selectedVisibleToUser}
                                onChange={(e) => setSelectedVisibleToUser(e)}
                                filterOption={createFilter({ ignoreAccents: false })}
                                captureMenuScroll={false}
                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
                <div className="col col-md-4"></div>
                <div className="col col-md-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <label>Account Owner:</label>
                        <div>
                            <Select
                                options={accountOwnerSelectData}
                                value={selectedAccountOwner}
                                onChange={(e) => setSelectedAccountOwner(e)}
                                filterOption={createFilter({ ignoreAccents: false })}
                                captureMenuScroll={false}
                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                styles={customStyles}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/*  */}
            <div className="row d-flex justify-content-center mt-1 align-items-center">
                <span
                    class="input-group-text"
                    role="button"
                    onClick={() => createNewAccountManager()}
                >
                    New Account</span>
        <span
            class="input-group-text ml-4"
            role="button"
            onClick={() => retrieveReport()}
        >
Search
        </span>
                <span class="input-group-text ml-4" role="button" onClick={handleReset}>
          Clear Search Options
        </span>
            </div>
            {/*  */}
            <div className="mt-3">
                {/*{isTableVisible && <Table columns={columns} data={data} />}*/}
                {isTableVisible &&<DataTableExtensions
                    columns={datacolumns}
                    data={data}
                    print={false}
                    export={false}
                >

                    <DataTable
                        columns={datacolumns}
                        data={data}
                        noHeader
                        pagination
                        highlightOnHover
                        pointerOnHover
                        paginationServer
                        paginationTotalRows={totalRecords}
                        paginationPerPage={perPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        onRowClicked={onRowClicked}
                        onChangePage={page => setCurrentPage(page)}
                        customStyles={tableStyles}
                    />
                </DataTableExtensions>}
            </div>
        </div>
    );
}

export default AccountManagerDatatable;
